<template>
  <div>
    <!-- Design: Normal Category -->
    <value_link v-if="filter_item['fl_subcats'] === undefined" :filter_item="filter_item" />
    <!-- Design: showSubCatoryies -->
    <div class="filter-header-cat"
         v-if="filter_item['fl_subcats'] !== undefined"
    >
      <div class="filter-cat-root" >
        <value_link :filter_item="filter_item"></value_link>
      </div>
      <div class="filter-cat-extend" @click.stop="toggleSubCats()">
        <i class="fa-solid fa-chevron-right" :class="{'extend': showSubCatoryies}"></i>
      </div>
    </div>

    <div class="pl-2" v-if="showSubCatoryies">
      <value_link v-for="subcat_item in filter_item['fl_subcats']"
                    :key="subcat_item.fl_catid"
                    :filter_item="subcat_item"/>
    </div>
  </div>
</template>

<script>
import value_link from "./value_link";

export default {
  name: "value_fl_cat_select",
  props: ['filter_item'],
  data() {
    return {
      showSubCatoryies: false,
    }
  },
  components: {
    value_link,
  },
  created() {
    if (this.$props.filter_item.fl_isParentCategory || this.$props.filter_item.selected) {
      this.showSubCatoryies = true
    }
  },
  methods: {
    toggleSubCats() {
      this.showSubCatoryies = !this.showSubCatoryies;
    },
  },
}
</script>

<style scoped>
.filter-header-cat {
  display: flex;
  padding-right: 3px;
  border-bottom: 1px solid #f0f0f0;
}
.filter-cat-root {
  width: 100%;
}
.filter-cat-root a {
  border: 0 none;
}
.filter-cat-root .value-link {
  margin-right: 10px;
}
.filter-cat-extend {
  padding: 7px 0;
}
.filter-cat-extend > i {
  font-size: 0.9rem;
  line-height: 1.7rem;
  transform: rotate(0);
  transition: all .1s ease;
}
.filter-cat-extend > i.extend {
  transform: rotate(90deg);
}
</style>
